export default __webpack_public_path__ + "static/media/01.252780e9.jpg";